import argumentDataSources from '@/schema/argumentDataSources';
import { supportsServerIpOverride } from '@shared/utils/supportsServerIpOverride.js';

const getWorkflowAdvancedFields = ({ timezones, environments, dataSource, app, auth }) => {
  const fields = [];

  if (supportsServerIpOverride({ app, auth })) {
    fields.push({
      key: 'serverIpOverride',
      name: 'Server IP address',
      dataType: 'string',
      isSensitive: false,
      required: false,
      description: 'Optional public IP address for your API server when its hostname does not resolve. Keep the HTTPS hostname and port in the API URL. Redirects are disabled when set.'
    });
  }

  if (timezones && timezones.length > 0) {
    fields.push({ key: 'timezone', name: 'Time Zone', placeholder: 'Select Time Zone', dataType: 'list', options: timezones, nullable: true, nullableLabel: 'None' });
  }

  const envOptions = environments?.map((env) => ({ label: env.name, value: env.id })) || [];

  if (environments && environments.length > 0 && dataSource !== argumentDataSources.appAuthenticationInstance) {
    fields.push({
      key: 'environmentId',
      name: 'Workflow Environment',
      placeholder: 'Select Environment',
      dataType: 'list',
      options: envOptions,
      nullable: true,
      nullableLabel: 'None'
    });
  }

  return fields;
};

export default getWorkflowAdvancedFields;
